module.exports = __webpack_public_path__ + "static/media/butt_instmod.6c8f441f.png";